<script src="../../eventBus.js"></script>
<style scoped lang="less">
.statistics {
  margin-bottom: 10px;

  label {
    font-weight: 600;
  }
}
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>订单管理</Breadcrumb-item>
        <Breadcrumb-item>订单列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row class-name="statistics">
          <i-col :md="4">
            筛选实付金额: <label>{{ filterStatistics.totalPayment }}</label>
          </i-col>
          <i-col :md="3">
            筛选金额: <label>{{ filterStatistics.totalAmount }}</label>
          </i-col>
          <i-col :md="3">
            筛选折扣: <label>{{ filterStatistics.totalDiscount }}</label>
          </i-col>
        </Row>
        <Row>
          <i-col :span="7">
            <Form-item label="创建时间">
              <Row>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd" placeholder="请选择日期"
                               @on-change="startCreateDateChange"
                               :value="queryParam.startCreateDate"></Date-picker>
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd" placeholder="请选择日期"
                               @on-change="endCreateDateChange"
                               :value="queryParam.endCreateDate"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </i-col>
          <i-col :span="7">
            <Form-item label="付款时间">
              <Row>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd" placeholder="请选择日期"
                               @on-change="startTimeDateChange"
                               :value="queryParam.startTimeDate"></Date-picker>
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd" placeholder="请选择日期"
                               @on-change="endTimeDateChange"
                               :value="queryParam.endTimeDate"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4">
            <Form-item label="创建人">
              <Select filterable clearable placeholder="全部" v-model="queryParam.creatorId" @on-change="search">
                <Option v-for="item in adminUser" :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4">
            <Form-item label="审核人">
              <Select filterable clearable placeholder="全部" v-model="queryParam.auditId" @on-change="search">
                <Option v-for="item in adminUserAudit" :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4">
            <Form-item label="审核状态">
              <Select v-model="queryParam.auditStatus" placeholder="全部" @on-change="search" clearable>
                <Option value="0">未审核</Option>
                <Option value="1">已审核</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4">
            <Form-item label="学生ID" prop="uid">
              <Input name="uid" v-model="queryParam.uid"/>
            </Form-item>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4">
            <Form-item label="状态">
              <Select v-model="queryParam.stateList" placeholder="全部" @on-change="search" clearable multiple>
                <Option value="2">订单已添加</Option>
                <Option value="0">待支付</Option>
                <Option value="1">支付成功</Option>
              </Select>
            </Form-item>
          </i-col>
<!--          <i-col :xs="4" :sm="4" :md="4">-->
<!--            <Form-item label="是否配送教材" :label-width="100">-->
<!--              <Select v-model="queryParam.presented" placeholder="全部" @on-change="search" clearable>-->
<!--                <Option value="1">是</Option>-->
<!--                <Option value="2">否</Option>-->
<!--              </Select>-->
<!--            </Form-item>-->
<!--          </i-col>-->
          <i-col ::xs="4" :sm="4" :md="4">
            <Form-item label="课程类型">
              <Select v-model="queryParam.tchChannel" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in $constant.tchChannel"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="8" :sm="8" :md="6">
            <Form-item label="订单号" prop="uid">
              <Input name="uid" v-model="queryParam.orderId"/>
            </Form-item>
          </i-col>
          <i-col :xs="12" :sm="12" :md="6">
            <Form-item label="订单类型">
              <Select v-model="queryParam.channelList" placeholder="全部" @on-change="search" clearable multiple>
                <Option v-for="item in $constant.orderChannel"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="12" :sm="12" :md="6">
            <Form-item label="套餐">
              <Select v-model="queryParam.coursePackageList" placeholder="全部" @on-change="search" clearable multiple>
                <Option value="1-20">欧美20</Option>
                <Option value="1-40">欧美40</Option>
                <Option value="1-50">欧美50</Option>
                <Option value="1-72">欧美72</Option>
                <Option value="1-110">欧美110</Option>
                <Option value="1-144">欧美144</Option>
                <Option value="1-210">欧美210</Option>
                <Option value="2-60">菲教60</Option>
                <Option value="2-100">菲教100</Option>
                <Option value="2-320">菲教320</Option>
                <Option value="2-630">菲教630</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="12" :sm="12" :md="12" offset="1">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
            <Button type="primary" @click="addModal=true">添加订单</Button>
            <Button type="primary" :disabled="showAddOtherButton" @click="addOtherModal=true">添加补升订单</Button>
            <Button type="primary" @click="exportData" :loading="exportLoading" v-perm="'713'">导出</Button>
          </i-col>
        </Row>
      </Form>
    </div>
    <List :height="680" ref="dataList" :tableColumns="title" :reload="reload" listUrl="/fundPackage/list"
          :params="queryParam" :onLoading="onLoading" :onSelection="onSelection" operator=""
          @on-sort-change="handleSortChange"></List>
    <add-order-modal :value="addModal" @on-close="addModal=false" :successCallback="search"></add-order-modal>
    <edit-order-modal :value="editModal" @on-close="editModal=false" :fundData="editData"
                      :successCallback="search"></edit-order-modal>
    <add-other-order-modal :value="addOtherModal" @on-close="addOtherModal=false"
                           :successCallback="search"></add-other-order-modal>
    <add-voucher-modal :value="addVoucherModal" @on-close="addVoucherModal=false" :data="editData"
                       :successCallback="search"></add-voucher-modal>
    <order-gift-modal :value="giftModal" :order-id="giftOrderId" @on-close="giftModal=false"></order-gift-modal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
    <OrderClassHourModal :totalNum="totalNum" :fundPackageId="fundPackageId" :uid="uid"
                         v-model="showOrderClassHourModal"></OrderClassHourModal>
  </div>

</template>
<script>
import AddOrderModal from './AddOrderModal.vue'
import EditOrderModal from './EditOrderModal.vue'
import UserCredential2 from './UserCredential2.vue'
import UserCredential from './UserCredential.vue'
import AddOtherOrderModal from './AddOtherOrderModal.vue'
import AddVoucherModal from './AddVoucherModal.vue'
import OrderGiftModal from './OrderGiftModal.vue'
import ShowImageCarousel from './ShowImageCarousel.vue'
import OrderClassHourModal from './OrderClassHourModal.vue'
import { fetchTchScoreMap, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  components: {
    AddOrderModal,
    EditOrderModal,
    UserCredential,
    UserCredential2,
    AddOtherOrderModal,
    AddVoucherModal,
    OrderGiftModal,
    OrderClassHourModal,
    ShowImageCarousel
  },
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    let $numeral = this.$numeral
    let self = this
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
      fundPackageId: null,
      uid: null,
      totalNum: null,
      statistics: {
        totalPayment: 0,
        totalAmount: 0,
        totalDiscount: 0,
      },

      filterStatistics: {
        totalPayment: 0,
        totalAmount: 0,
        totalDiscount: 0,
      },

      queryParam: {
        uid: '',
        creatorId: null,
        auditId: null,
        auditStatus: null,
        state: '',
        stateList: [],
        startTimeDate: '',
        endTimeDate: '',
        startCreateDate: '',
        endCreateDate: '',
        presented: null,
        tchChannel: null,
        channel: null,
        channelList: [],
        sorts: [],
        coursePackage: '',
        coursePackageList: [],
      },
      adminUser: [],
      adminUserAudit: [],
      isDepLeader: true,
      editData: null,
      loadingEdit: false,
      editModal: false,
      addModal: false,
      addOtherModal: false,
      showAddOtherButton: true,
      addVoucherModal: false,
      giftModal: false,
      giftOrderId: '',
      showImgModal: false,
      showImgList: [],
      showOrderClassHourModal: false,
      formData: {
        livingNum: 0,
        chineseNum: 0,
        bookNum: 0,
        cdNum: 0,
        leaveNum: 0,
        address: '',
        contractName: ''
      },
      formRule: {},
      title: [
        {
          title: '学生ID',
          fixed: 'left',
          width: 80,
          render: (h, params) => {
            let row = params.row
            if (row.seeStdDetail === true) {
              return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid)
            }
            return h('a', row.uid)
          }
        },
        {
          title: '学生姓名',
          width: 150,
          align: 'center',
          key: 'nickname',
          fixed: 'left'
        },
        {
          title: '订单类型',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let channel = row.channel
            let channelEnum = $constant.getEnum($constant.orderChannel, channel)
            return h('div', channelEnum && channelEnum.text)
          },
          key: 'channel'
        },
        {
          title: '订单号',
          width: 150,
          align: 'center',
          key: 'orderId'
        },
        {
          title: '外教课节',
          width: 95,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.tchChannel === 1) {
              return h('span', row.num)
            }
            return h('div', [
              h('a', {on: {click: () => this.showOrderClassHour(row)}}, row.num)
            ])
          }
        },
        {
          title: '赠送课时',
          width: 95,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.tchChannel === 1) {
              return h('span', row.discountNum)
            }
            return h('span', '<<-看左边')
          }
        },
        // {
        //   title: '陪练课节',
        //   width: 95,
        //   align: 'right',
        //   key: 'partnerNum'
        // },
        // {
        //   title: '直播课节',
        //   width: 95,
        //   align: 'right',
        //   key: 'livingNum'
        // },
        // {
        //   title: '辅修课节',
        //   width: 95,
        //   align: 'right',
        //   key: 'minorNum'
        // },
        // {
        //   title: '请假次数',
        //   width: 95,
        //   align: 'right',
        //   key: 'leaveNum'
        // },
        // {
        //   title: '补课次数',
        //   width: 95,
        //   align: 'right',
        //   key: 'makeupLessonNum'
        // },
        {
          title: '套餐金额',
          width: 100,
          key: 'amount',
          align: 'center',
          render: (h, params) => {
            return h('span', $numeral(params.row.amount).format('0,0.00'))
          }
        },
        {
          title: '优惠金额',
          width: 100,
          key: 'discount',
          align: 'center',
          render: (h, params) => {
            return h('span', $numeral(params.row.discount).format('0,0.00'))
          }
        },
        {
          title: '实付金额',
          width: 120,
          key: 'payAmount',
          align: 'center',
          render: (h, params) => {
            return h('span', $numeral(params.row.payAmount).format('0,0.00'))
          }
        },
        {
          title: '支付状态',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let state = params.row.state
            let stateEnum = $constant.getEnum($constant.fundPackageState, state)
            return h('div', stateEnum && stateEnum.text)
          }
        },
        {
          title: '课程类型',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let tchChannel = params.row.tchChannel
            let tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel)
            return h('div', tchChannelEnum && tchChannelEnum.text)
          }
        },
        {
          title: '支付方式',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let payWay = params.row.payWay
            let stateEnum = $constant.getEnum($constant.payWayNew, payWay)
            return h('div', stateEnum && stateEnum.text)
          }
        },
        {
          title: '支付凭证',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.url) {
              return h('a', {on: {click: () => this.viewPic(row)}}, '查看凭证')
            } else {
              return h('span', '')
            }
          }
        },
        // {
        //   title: '配送教材',
        //   width: 200,
        //   key: 'bookNum'
        // },
        // {
        //   title: '邮寄地址',
        //   width: 200,
        //   key: 'address'
        // },
        {
          title: '绑定老师',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.tchBoundNum && row.tchBoundNum > 0) {
              let list = row.bookWorkLessonOpenedTimeList
              let spanArr = []
              const scoreMap = this.rankScoreMap || {}
              if (list) {
                list.forEach(function (element) {
                  let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                  spanArr.push(h('span', [
                    renderTchNameWithScore(h, { text: element.tchId + '-' + element.tchName, score: scoreMap[element.tchId] != null ? scoreMap[element.tchId] : scoreMap[String(element.tchId)] }),
                    h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]))
                  spanArr.push(h('br'))
                })
              }
              let levelTitle = row.levelTitle
              if (levelTitle) {
                levelTitle = '当前等级：' + levelTitle
              }
              return h('div', {style: {'font-size': '12px'}}, [h('p', levelTitle), h('p', spanArr)])
            } else {
              return h('div', '未绑定')
            }
          }
        },

        {
          title: '试听课外教',
          width: 180,
          align: 'center',
          key: 'demoTchName',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.demoTchName,
              score: row.monthRankScoreDemo
            })
          }
        },

        {
          title: '创建人',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let creatorId = params.row.creatorId
            let creatorName = params.row.creatorName
            return h('div', [h('span', creatorId), h('br'), h('span', creatorName)])
          }
        },
        {
          title: '创建时间',
          width: 170,
          align: 'center',
          key: 'createTime',
          sortable: 'custom',
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          title: '支付时间',
          width: 170,
          align: 'center',
          key: 'lastPayTime',
          sortable: 'custom',
          render: (h, params) => {
            return h('span', params.row.lastPayTime)
          }
        },
        {
          title: '审核人',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let auditId = params.row.auditId
            let auditName = params.row.auditName
            return h('div', [h('span', auditId), h('br'), h('span', auditName)])
          }
        },
        {
          title: '审核时间',
          width: 170,
          align: 'center',
          key: 'auditTime',
          sortable: 'custom',
          render: (h, params) => {
            let auditTime = params.row.auditTime
            return h('span', auditTime)
          }
        },
        {
          title: '合同确认时间',
          width: 170,
          align: 'center',
          key: 'contractConfirmDate',
          sortable: 'custom'
        },
        {
          title: '合同确认人',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let confirmUser = params.row.confirmUser
            if (!confirmUser) {
              confirmUser = ''
            }
            let style = {}
            if (confirmUser === '学生本人') {
              style.color = '#19be6b' // 绿色
            } else if (confirmUser === '系统自动确认') {
              style.color = '#ff9900' // 橙色
            }
            return h('span', { style: style }, confirmUser)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 130,
          fixed: 'right',
          render: (h, params) => {
            let row = params.row
            let btn = []
            btn.push(h('Dropdown-item', {props: {name: 'onPreview'}}, '预览合同'))
            btn.push(h('Dropdown-item', {props: {name: 'uploadVoucher'}}, '上传凭证'))
            if (row.state === 0 || row.state === 1 || params.row.state === 4 || params.row.state === 5) {
              btn.push(h('Dropdown-item', {props: {name: 'onOpen'}}, '开启合同'))
            }
            if (row.state !== 3) {
              btn.push(h('Dropdown-item', {props: {name: 'closeOrder'}}, '关闭合同'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'sendContract'}}, '发送合同'))
            if (params.row.state !== 3) {
              btn.push(h('Dropdown-item', {props: {name: 'onPrint'}}, '打印凭据'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'delOrder'}}, '删除订单'))
            if (row.contractVersion === 2 || row.tchChannel === 2) {
              btn.push(h('Dropdown-item', {props: {name: 'editContract'}}, '编辑合同'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'onEdit'}}, '编辑'))
            btn.push(h('Dropdown-item', {props: {name: 'giftOrder'}}, '赠送礼品'))
            /*
            if (params.row.state === 1 || params.row.state === 5) {
              btn.push(h('Dropdown-item', {props: {name: 'financialAudit'}}, '财务审核'))
            }
            */
            return h('div', [
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                },
                on: {
                  'on-click': (name) => {
                    if (name === 'onEdit') {
                      self.onEdit(row)
                    } else if (name === 'onPreview') {
                      self.onPreview(row)
                    } else if (name === 'editContract') {
                      self.editContract(row)
                    } else if (name === 'uploadVoucher') {
                      self.uploadVoucher(row)
                    } else if (name === 'onPrint') {
                      self.onPrint(row)
                    } else if (name === 'onOpen') {
                      self.onOpen(row)
                    } else if (name === 'onActivate') {
                      self.onActivate(row)
                    } else if (name === 'closeOrder') {
                      self.closeOrder(row)
                    } else if (name === 'hideContract') {
                      self.hideContract(row)
                    } else if (name === 'delOrder') {
                      self.delOrder(row)
                    } else if (name === 'sendContract') {
                      self.sendContract(row)
                    } else if (name === 'financialAudit') {
                      self.financialAudit(row)
                    } else if (name === 'giftOrder') {
                      self.openGift(row)
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ]),
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    let self = this
    let queryParam = this.queryParam
    queryParam.uid = this.$route.query.uid

    // 检查是否为部门负责人
    let depLeader = this.$store.get('depLeader')
    if (depLeader !== true) {
      self.isDepLeader = false
      // 如果不是部门负责人，默认创建人为当前登录用户
      queryParam.creatorId = this.$store.get('id')
    }

    this.$http.post('/adminUser/listByCondition', {status: 1, groupIds: [4, 10]}).then(function (res) {
      self.adminUser = res.data
    })
    this.$http.post('/adminUser/listByCondition', {status: 1, idSet: [224, 581, 360, 462]}).then(function (res) {
      self.adminUserAudit = res.data
    })

    this.$http.post('/common/getPermissionByUrl', {url: '/fundPackage/insertOther'}).then(function (res) {
      if (res.data) {
        self.showAddOtherButton = false
      }
    })
  },
  created: function () {
    // 默认付款时间开始时间为当月 1 号
    this.queryParam.startTimeDate = this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
    this.filterStatistic()
  },
  methods: {
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookTestList'}
      })
      window.open(href, '_blank')
    },
    closeImgModal () {
      this.showImgList = []
      this.showImgModal = false
    },
    search () {
      this.reload = new Date().getTime()
      this.filterStatistic()
    },
    search2 () {
      this.reload = new Date().getTime()
    },
    startTimeDateChange (value) {
      if (value) {
        this.queryParam.startTimeDate = value
      } else {
        this.queryParam.startTimeDate = ''
      }
    },
    endTimeDateChange (value) {
      if (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
        this.queryParam.endTimeDate = value
      } else {
        this.queryParam.endTime = ''
        this.queryParam.endTimeDate = ''
      }
    },
    startCreateDateChange (value) {
      if (value) {
        this.queryParam.startCreateDate = value
      } else {
        this.queryParam.startCreateDate = ''
      }
    },
    endCreateDateChange (value) {
      if (value) {
        this.queryParam.endCreateDate = value
      } else {
        this.queryParam.endCreateDate = ''
      }
    },
        onLoading (loading) {
      this.searchLoading = loading
    
      if (!loading) {
        this.loadBoundTchMonthScores()
      }
    },
    loadBoundTchMonthScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        this.rankScoreMap = {}
        return
      }
      const ids = []
      table.forEach(function (row) {
        const list = row.bookWorkLessonOpenedTimeList || []
        list.forEach(function (el) {
          if (el && el.tchId != null) {
            ids.push(el.tchId)
          }
        })
        if (row.demoTchId != null) {
          ids.push(row.demoTchId)
        }
      })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        self.rankScoreMap = map || {}
        table.forEach(function (row) {
          let score = map[row.demoTchId]
          if (score == null) {
            score = map[String(row.demoTchId)]
          }
          self.$set(row, 'monthRankScoreDemo', score == null ? null : score)
        })
      })
    },
    onSelection (selection) {
      this.selection = selection
    },
    delAll () {
      this.$refs.dataList.delAll()
    },
    onEdit (row) {
      this.editData = row
      this.editModal = true
    },
    onPreview (row) {
      let self = this
      if (row.tchChannel === 1) {
        if (row.contractVersion === 2) {
          if (self.$appConfig.active === 'prod') {
            window.open('https://h5.speakstreet.cn/contract/contract.html?fundPackageId=' + row.id)
          } else {
            window.open('https://test-h5.kouyujie.cn/contract/contract.html?fundPackageId=' + row.id)
          }
        } else {
          if (self.$appConfig.active === 'prod') {
            window.open('https://hellokid.speakstreet.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid)
          } else {
            window.open('https://test-student.kouyujie.cn/fundPackage/contract?fundPackageId=' + row.id + '&uid=' + row.uid)
          }
        }
      } else if (row.tchChannel === 2) {
        if (self.$appConfig.active === 'prod') {
          window.open('https://h5.speakstreet.cn/contract/contract.html?fundPackageId=' + row.id)
        } else {
          window.open('https://test-h5.kouyujie.cn/contract/contract.html?fundPackageId=' + row.id)
        }
      }
    },
    viewPic (row) {
      this.showImgList = row.urls
      this.showImgModal = true
    },
    uploadVoucher (row) {
      this.editData = row
      if (row.payTime) {
        this.editData.payTime = row.payTime * 1000
      }
      this.addVoucherModal = true
    },
    openGift (row) {
      this.giftOrderId = row.orderId
      this.giftModal = true
    },
    editContract (row) {
      this.$router.push({path: '/student-contract', query: {row: row}})
    },
    onPrint (row) {
      if (row.id <= 17209) {
        this.$router.push({path: '/order/userCredential2?orderSn=' + row.orderId})
      } else {
        this.$router.push({path: '/order/userCredential?orderSn=' + row.orderId})
      }
    },
    onOpen (row) {
      this.$http.get('/fundPackage/openFundPackage', {params: {id: row.id}}).then(res => {
        if (res && res.data > 0) {
          this.$Message.success('合同开启成功!')
          this.search()
        }
      })
    },
    financialAudit (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认该订单审核通过？',
        width: 300,
        okText: '确认通过',
        onOk: () => {
          self.$http.get('/fundPackage/financialAudit', {params: {id: row.id}}).then(res => {
            if (res && res.data > 0) {
              self.$Message.success('合同审核成功!')
              self.$Modal.remove()
              self.search()
            }
          })
        }
      })
    },
    onActivate (row) {
      this.$http.get('/fundPackage/activateFundPackage', {params: {id: row.id}}).then(res => {
        if (res && res.data > 0) {
          this.$Message.success('激活成功!')
          this.search()
        }
      })
    },
    exportData () {
      this.exportLoading = true
      let params = {}
      this.$helper.mergeProperties(this.queryParam, params)
      this.$http.get('/fundPackage/export', {responseType: 'arraybuffer', params: params}).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '订单列表.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
        this.$Message.error('无权限')
      })
    },
    closeOrder (row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">关闭</span>该合同?',
        width: 300,
        okText: '确认关闭',
        loading: true,
        onOk: () => {
          this.$http.get('/fundPackage/closeOrder', {params: {orderSn: row.orderId}}).then(res => {
            if (res && res.data > 0) {
              this.$Message.success('关闭成功')
              this.$Modal.remove()
              this.search()
            }
          })
        }
      })
    },

    hideContract (row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">' + row.enabled === true ? '隐藏' : '显示' + '</span>该合同?',
        width: 300,
        okText: row.enabled === true ? '确认隐藏' : '确认显示',
        loading: true,
        onOk: () => {
          this.$http.get('/fundPackage/hideContract', {params: {fundPackageId: row.id, enabled: !row.enabled}}).then(res => {
            if (res && res.data > 0) {
              this.$Message.success('操作成功')
              this.$Modal.remove()
              this.search()
            }
          })
        }
      })
    },
    delOrder (row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">删除</span>当前订单?',
        width: 300,
        okText: '确认删除',
        loading: true,
        onOk: () => {
          this.$http.get('/fundPackage/delOrder', {params: {orderSn: row.orderId}}).then(res => {
            if (res && res.data > 0) {
              this.$Message.success('删除成功')
              this.$Modal.remove()
              this.search()
            }
          })
        }
      })
    },
    sendContract (row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否<span style="color: red">发送短信</span>提醒用户签署?',
        width: 300,
        okText: '确认发送',
        loading: true,
        onOk: () => {
          this.$http.get('/fundPackage/sendContract', {params: {id: row.id}}).then(res => {
            if (res && res.status === 'ok') {
              this.$Message.success('发送成功')
              this.$Modal.remove()
            }
          })
        }
      })
    },
    edit () {
      let self = this
      self.loadingEdit = true
      self.$refs.form.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingEdit = false
          return
        }
        let path = '/fundPackage/save'
        self.$http.post(path, self.formData).then(function (res) {
          if (res && res.data > 0) {
            self.editModal = false
            self.$Message.success('提交成功!')
            self.search()
          }
          self.loadingEdit = false
        })
      })
    },
    filterStatistic () {
      this.$http.get('/fundPackage/statistics', {params: this.queryParam}).then(res => {
        this.filterStatistics = res.data
      })
    },
    showOrderClassHour (row) {
      this.uid = row.uid
      this.totalNum = row.num
      this.fundPackageId = row.id
      this.showOrderClassHourModal = true
    },
    handleSortChange (column, key, order) {
      // 清除之前的排序参数
      delete this.queryParam.sorts

      // 根据后端期望的格式构造参数
      if (order && order !== 'normal') {
        this.queryParam.sorts = [{
          property: key,
          direction: order
        }]
      }

      // 执行搜索
      this.search2()
    }
  }
}
</script>



// WEBPACK FOOTER //
// FundPackageList.vue?299a368b